export default __webpack_public_path__ + "static/media/leftArrow.2e05f936.svg";